const urlRegex = /(https?:\/\/\S+)/g;

const invisibleCharacterRegex = /[\u00A0\u200B-\u200D\u202A-\u202E\u2060\u2066-\u2069\uFEFF]/g;

const stripInvisibleCharacters = value => value.split(invisibleCharacterRegex).join('');

export const renderTextWithLinks = text => {
    const elements = [];
    let lastIndex = 0;

    for (const match of text.matchAll(urlRegex)) {
        const index = match.index ?? 0;
        const url = match[0];
        const sanitizedUrl = stripInvisibleCharacters(url);
        if (index > lastIndex) {
            elements.push(text.slice(lastIndex, index));
        }
        elements.push(
            <a
                key={`link-${index}-${url}`}
                href={sanitizedUrl}
                target="_blank"
                rel="noreferrer noopener"
                style={{ color: 'inherit' }}
            >
                {sanitizedUrl}
            </a>,
        );
        lastIndex = index + url.length;
    }

    if (lastIndex < text.length) {
        elements.push(text.slice(lastIndex));
    }

    return elements;
};
